angular.module('SpidApp')

.controller('LogoutController',
        ['$state', 'LoginService',
function ($state,   LoginService) {
	
	LoginService.logout().then(function () {
		$state.go('login')
	})
	
}])
